module.exports = __webpack_public_path__ + "static/media/hanakawado-asakusa-7.e2e58473.jpg";